import { render } from "./DFile.vue?vue&type=template&id=53fc3f8c&scoped=true"
import script from "./DFile.vue?vue&type=script&lang=js"
export * from "./DFile.vue?vue&type=script&lang=js"

import "./DFile.vue?vue&type=style&index=0&id=53fc3f8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fc3f8c"]])

export default __exports__